// src/stores/useProductLayerStore.js
//
// Tracks "product-owned" map layers — layers added directly to MapLibre
// by product components (SiteLayer, WellLayer) that bypass useLayerRegistryStore.
//
// Usage:
//   On mount:   useProductLayerStore.getState().registerProductLayers(entries)
//   On unmount: useProductLayerStore.getState().clearProductLayers(productKey)
//
// Each entry: { id, label, productKey, dotColor }
 
import { create } from "zustand";
 
export const useProductLayerStore = create((set, get) => ({
 
  // id → { id, label, productKey, dotColor, visible }
  layers: {},
 
  registerProductLayers: (entries) => {
    set(state => {
      const next = { ...state.layers };
      entries.forEach(e => {
        next[e.id] = {
          id:         e.id,
          label:      e.label,
          productKey: e.productKey,
          dotColor:   e.dotColor ?? "#1f9dff",
          visible:    e.visible ?? false,
        };
      });
      return { layers: next };
    });
  },
 
  clearProductLayers: (productKey) => {
    set(state => {
      const next = {};
      Object.values(state.layers).forEach(l => {
        if (l.productKey !== productKey) next[l.id] = l;
      });
      return { layers: next };
    });
  },
 
  setProductLayerVisible: (id, visible) => {
    set(state => {
      const layer = state.layers[id];
      if (!layer) return state;
      return { layers: { ...state.layers, [id]: { ...layer, visible } } };
    });
  },
 
  reset: () => set({ layers: {} }),
}));